<template>
  <div class="wallet">
    <CardHead></CardHead>
    <div class="divider"></div>
    <TradeDetail></TradeDetail>
  </div>
</template>

<script>
import CardHead from './cardHead';
import TradeDetail from './tradeDetail';
export default {
  components: {
    CardHead,
    TradeDetail
  }
};
</script>

<style lang="postcss" scoped>
.divider {
  height: 10px;
  margin-left: -40px;
  margin-right: -40px;
  background-color: #F3F4F7;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/account/wallet/index.vue